import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { i18n } from '../services/i18n';

const { REACT_APP_API_BASE_URL, REACT_APP_API_BASE_DOCGEN_URL } = process.env;

const baseQuery = fetchBaseQuery({
  baseUrl: REACT_APP_API_BASE_URL,
  credentials: 'include',
  prepareHeaders: (headers) => {
    headers.set('lang', i18n.resolvedLanguage ?? 'en');
    return headers;
  },
});

const baseDocgenQuery = fetchBaseQuery({
  baseUrl: REACT_APP_API_BASE_DOCGEN_URL,
  credentials: 'include',
  prepareHeaders: (headers) => {
    return headers;
  },
});

const enhancedBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    const oryLoginUrl = `${process.env.REACT_APP_UI_ORY_SDK_URL}/login?return_to=${window.location.href}`;
    window.location.replace(oryLoginUrl);
  }

  return result;
};

const enhancedBaseDocgenQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseDocgenQuery(args, api, extraOptions);

  // here place to write some interceptors logic
  if (result.error && result.error.status === 401) {
    // code of interceptor is here...
  }

  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: enhancedBaseQuery,
  endpoints: () => ({}),
  tagTypes: [
    'RateMarkups',
    'CurrentProfile',
    'Countries',
    'CompanyTypes',
    'Transaction',
    'Transactions',
    'ProfileTransactions',
    'Wallets',
    'BankAccounts',
    'Documents',
    'TransitAddresses',
    'Fees',
    'Applications',
    'ApplicationTokens',
    'NotificationTemplates',
    'NotificationTemplate',
  ],
});

export const apiDocgenSlice = createApi({
  reducerPath: 'api',
  baseQuery: enhancedBaseDocgenQuery,
  endpoints: () => ({}),
});
